// CBJJ championship classification labels (pt-BR, official CBJJ names).
// Keys mirror the backend's Cbjj::Classification stable snake_case keys.

const AGE_DIVISION_LABELS: Record<string, string> = {
  pre_mirim_1: 'Pré-Mirim I',
  pre_mirim_2: 'Pré-Mirim II',
  pre_mirim_3: 'Pré-Mirim III',
  mirim_1: 'Mirim I',
  mirim_2: 'Mirim II',
  mirim_3: 'Mirim III',
  infantil_1: 'Infantil I',
  infantil_2: 'Infantil II',
  infantil_3: 'Infantil III',
  infanto_juvenil_1: 'Infanto-Juvenil I',
  infanto_juvenil_2: 'Infanto-Juvenil II',
  infanto_juvenil_3: 'Infanto-Juvenil III',
  juvenil_1: 'Juvenil I',
  juvenil_2: 'Juvenil II',
  adulto: 'Adulto',
  master_1: 'Master 1',
  master_2: 'Master 2',
  master_3: 'Master 3',
  master_4: 'Master 4',
  master_5: 'Master 5',
  master_6: 'Master 6',
  master_7: 'Master 7',
};

const WEIGHT_CATEGORY_LABELS: Record<string, string> = {
  galo: 'Galo',
  pluma: 'Pluma',
  pena: 'Pena',
  leve: 'Leve',
  medio: 'Médio',
  meio_pesado: 'Meio-Pesado',
  pesado: 'Pesado',
  super_pesado: 'Super Pesado',
  pesadissimo: 'Pesadíssimo',
};

export function getAgeDivisionLabel(key: string | null | undefined): string | null {
  return key ? (AGE_DIVISION_LABELS[key] ?? null) : null;
}

export function getWeightCategoryLabel(key: string | null | undefined): string | null {
  return key ? (WEIGHT_CATEGORY_LABELS[key] ?? null) : null;
}
